export const SET_ACTIVITY_STATE_METHOD = 'InteractionInterface.v1_0.SetActivityFeedStateMethod';
export const ACTIVITY_STORAGE_KEY = 'ActivityFeedIds';
export const ACTIVITY_DIRTY_FLAG_KEY = 'newActivities';
